import script from "./SlotLocatorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SlotLocatorPage.vue?vue&type=script&setup=true&lang=js"

import "./SlotLocatorPage.vue?vue&type=style&index=0&id=5b66980a&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b66980a"]])

export default __exports__